export default __webpack_public_path__ + "static/logo-429b27ddf436651a0e6c303c4e255af0.png";